import { HttpClient, HttpClientModule } from '@angular/common/http';
import { Compiler, CompilerFactory, COMPILER_OPTIONS, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { JitCompilerFactory } from '@angular/platform-browser-dynamic';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CalcoloCodicefsComponent } from './calcolo-codicefs/calcolo-codicefs.component';
import { TokenHolder, TOKEN_HOLDER } from './email-content/communication-button/TokenHolder';
import { EmailContentComponent } from './email-content/email-content.component';
import { ExpiredPageComponent } from './expired-page/expired-page.component';
import { IssuePageComponent } from './issue-page/issue-page.component';
import { LoaderComponent } from './loader/loader.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { SendTermsComponent } from './send-terms/send-terms.component';
import { APP_INITIALIZER } from '@angular/core';
import { initializeApp } from './init/app-init';
import { SharedModule } from './shared/shared.module';

export function createCompiler(compilerFactory: CompilerFactory): Compiler {
  return compilerFactory.createCompiler();
}

@NgModule({
  declarations: [
    AppComponent,
    SendTermsComponent,
    CalcoloCodicefsComponent,
    EmailContentComponent,
    PageNotFoundComponent,
    IssuePageComponent,
    LoaderComponent,
    ExpiredPageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgbModule,
    SharedModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      multi: true,
      deps: [
        HttpClient
      ],
    },
    {
      provide: COMPILER_OPTIONS,
      useValue: {},
      multi: true
    },
    {
      provide: CompilerFactory,
      useClass: JitCompilerFactory,
      deps: [COMPILER_OPTIONS]
    },
    {
      provide: Compiler,
      useFactory: createCompiler,
      deps: [CompilerFactory]
    },
    {
      provide: TOKEN_HOLDER,
      useClass: TokenHolder
    }
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    LoaderComponent
  ]
})
export class AppModule {
}
